









































import { defineComponent, PropType, ref } from "@vue/composition-api";
import { ListField, ListFields } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import { languageList } from "@/views/PagePayeeInfo/config";

export default defineComponent({
  name: "FilterCreatorLanguageInput",
  components: { BaseIcon, CustomScroll, BaseInput },
  props: {
    languages: { type: Array as PropType<string[]>, default: [] },
  },
  setup(props, { emit }) {
    const language = ref<string>("");
    const showOptions = ref(false);
    const options = ref<ListFields>([]);
    const selectedLanguages = ref<ListFields>([]);
    const isSelectedFilters = ref(false);

    const getLanguage = async (text?: string) => {
      if (!text) {
        showOptions.value = false;
        return;
      }
      options.value = languageList.filter(item => item.text.toLowerCase().includes(text.toLowerCase()));
      showOptions.value = !!options.value.length;
    };

    const setLanguage = (value: ListField) => {
      showOptions.value = false;
      language.value = "";
      selectedLanguages.value.push(value);
      emit(
        "selectLanguages",
        selectedLanguages.value.map(i => i.value)
      );
    };

    const excludeLanguage = (value: string) => {
      selectedLanguages.value = selectedLanguages.value.filter(item => item.value !== value);
      emit(
        "selectLanguages",
        selectedLanguages.value.map(i => i.value)
      );
    };

    const clear = () => {
      selectedLanguages.value = [];
      emit("selectLanguages", selectedLanguages.value);
    };
    const created = () => {
      if (!props.languages.length) return;
      selectedLanguages.value = languageList.filter(item => props.languages.includes(item.value));
      isSelectedFilters.value = true;
    };

    created();

    return {
      language,
      showOptions,
      options,
      selectedLanguages,
      isSelectedFilters,
      getLanguage,
      setLanguage,
      excludeLanguage,
      clear,
    };
  },
});
